export interface Location {
	pathname: string
	search: string
	hash: string
	state: any
	key: string
}
export type BreadCrumb = {
	content: string
	path: string
}

export const flattenRoutes = (arr: any[]): any[] => {
	const val = arr.reduce((pre, cur) => {
		pre.push(cur)
		return pre.concat(Array.isArray(cur.children) ? flattenRoutes(cur.children) : [])
	}, [])
	return val
}

export const flatten = (arr: any[]): any[] => {
	return [].concat(...arr.map(item => (Array.isArray(item) ? flatten(item) : item)))
}

export const getBreadCrumbs = ({flattenRoutes, location}: {flattenRoutes: any; location: Location}) => {
	const matches: BreadCrumb[] = []
	location.pathname
		.split('?')[0]
		.split('/')
		.reduce((pre: string, cur: string) => {
			const pathSection = `${pre}/${cur}`
			// eslint-disable-next-line no-use-before-define
			const breadcrumb = getBreadCrumb({flattenRoutes, cur, pathSection})
			matches.push(breadcrumb)
			return pathSection
		})
	return matches
}

export const getBreadCrumb = ({
	flattenRoutes,
	cur,
	pathSection
}: {
	flattenRoutes: any
	cur: string
	pathSection: string
}) => {
	const matchRoute = flattenRoutes.find((ele: any) => {
		const {path} = ele
		return path === cur
	})
	if (matchRoute && matchRoute.breadcrumb) {
		return {
			content: matchRoute.title || '未定义',
			path: pathSection
		}
	}
	return {
		content: '',
		path: ''
	}
}
